//
import {
    VIcon,
    VProgressLinear,
    VProgressCircular,
    VSpacer,
    VSwitch,
    VBtnToggle,
} from 'vuetify/lib'
import {
    VStepper,
    VStepperContent,
    VStepperHeader,
    VStepperItems,
    VStepperStep,
} from 'vuetify/lib'
import { VTab, VTabs, VTabItem } from 'vuetify/lib'

//
import CrudFormFieldset from '../CrudFormFieldset'

//
export default {
    name: 'model-form',
    components: {
        'crud-form-fieldset': CrudFormFieldset,
        VBtnToggle,
        VIcon,
        VProgressLinear,
        VProgressCircular,
        VSpacer,
        VStepper,
        VStepperContent,
        VStepperHeader,
        VStepperItems,
        VStepperStep,
        VSwitch,
        VTab,
        VTabs,
        VTabItem,
    },
    computed: {
        /**
         *
         */
        fieldsSlots() {
            return this.fields.reduce(this.reduceSlots, [])
        },

        /**
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        incorrect() {
            return {
                response: {
                    data: { 
                        error: 'Faltan campos por rellenar.' 
                    },
                },                
            }
        },

        /**
         *
         */
        isDisabled() {
            return !this.isEditing
        },

        /**
         *
         */
        isEditing() {
            return this.edit && !this.wait
        },

        /**
         *
         */
        isPlain() {
            return this.variant === 'plain'
        },

        /**
         *
         */
        isReadonly() {
            return this.readonly || this.wait
        },

        /**
         *
         */
        isStepper() {
            return this.variant === 'stepper'
        },

        /**
         *
         */
        isStepperVertical() {
            return this.isStepper && this.vertical
        },

        /**
         *
         */
        isTabs() {
            return this.variant === 'tabs'
        },

        /**
         *
         */
        isValid() {
            return this.$refs.form && this.$refs.form.validate()
        },

        /**
         * @description
         * { function_description }
         *
         * @return  {Object}  The loading props params
         */
        loadingProps() {
            return {
                color: this.loadingColor,
                size: this.loadingSize,
                width: this.loadingWidth,
            }
        },

        /**
         * @description
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        progressProps() {
            return {
                color: this.loadingColor,
            }
        },

        /**
         * Shows the header.
         *
         * @return  {Boolean}  { description_of_the_return_value }
         */
        showHeader() {
            return this.title || this.switchEdit
        },

        /**
         * Shows the header actions.
         *
         * @return  {Boolean}  { description_of_the_return_value }
         */
        showHeaderActions() {
            return ! this.loading
        },

        /**
         * Shows the progress.
         *
         * @return  {Boolean}  { description_of_the_return_value }
         */
        showLoading() {
            return this.loading
        },

        /**
         * Shows the progress.
         *
         * @return  {Boolean}  { description_of_the_return_value }
         */
        showProgress() {
            return this.wait || this.loading
        },

        /**
         * Shows the title.
         *
         * @return  {Boolean}  { description_of_the_return_value }
         */
        showTitle() {
            return !! this.title
        },

        /**
         * @description
         * Scope props to action slots
         *
         * @return     {Object}  slot props
         */
        slotActionsProps() {
            return {
                disabled: this.wait || !this.isEditing,
                editable: this.isEditing,
                wait: this.wait,
            }
        },

        /**
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        submitProps() {
            return {
                disabled: this.wait || this.submitDisabled,
                type: this.submitType,
            }
        },

        /**
         * @descripcion
         * { function_description }
         *
         * @return  {Object}  { description_of_the_return_value }
         */
        switchEditProps() {
            return {
                disabled: this.wait,
                label: this.switchEditText,
            }
        },
    },
    data() {
        return {
            busy: false,
            data: {},
            edit: true,
            step: 0,
            tab: '',
            valid: false,
            wait: false,
        }
    },
    methods: {
        /**
         *
         */
        getField(name) {
            return this.fields.find(field => field.name === name)
        },

        /**
         *
         */
        getFieldset() {
            return this.$refs.fieldset
        },
        /**
         *
         */
        getInput(name) {
            return this.$refs.fieldset.$refs[name].slice().pop()
        },
        /**
         * 
         * @param {*} event 
         */
        getValue(fieldName) {
            return this.value[fieldName]
        },
        /**
         *
         */
        prevent(event) {
            if (this.submitPrevent) {
                event.preventDefault()
                event.stopPropagation()
            }
        },

        /**
         *
         */
        reduceSlots(slots, field) {
            //console.log(slots, field, this)

            // if has slots return merge between existents and new slots
            if (field.slots) {
                return slots.concat(Object.values(field.slots))
            }

            // else return existents slots
            return slots
        },

        /**
         *
         */
        reset() {
            this.edit = this.editable
        },

        /**
         *
         */
        async setWait(wait = false) {
            this.wait = wait
            return this.value
        },

        /**
         *
         */
        submit(event) {

            //
            console.log('submit')

            //
            const hasAttributes = !! event.explicitOriginalTarget
            const attributes = hasAttributes && event.explicitOriginalTarget.attributes
            const attribute = hasAttributes && attributes.getNamedItem('nosubmit')
            //
            const hasAttribute = !!attribute
            const hasNoSubmit = hasAttribute && attribute.value === 'true'
            console.log(hasNoSubmit)
            //
            if (!hasNoSubmit) {
                //
                if (this.validate()) {
                    this.$emit('submit', this.value)
                } else {
                    this.$emit('error', {
                        response: {
                            data: { error: 'Faltan campos por rellenar.' },
                        },
                    })
                }
            }
        },

        /**
         * @description
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitByClick(event) {
            return this.validate() ? this.submitValue() : this.submitError()
        },

        /**
         * @description
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitError() {
            return this.$emit('error', this.incorrect)
        },

        /**
         * @description
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitValue() {
            return this.$emit('submit', this.value)
        },

        /**
         *
         */
        validate() {
            return this.$refs.form.validate()
        },
    },
    props: {
        /**
         *
         */
        editable: {
            type: Boolean,
            default: true,
        },

        /**
         *
         */
        fields: {
            type: Array,
            default: () => [],
        },

        /**
         *
         */
        loading: Boolean,

        /**
         *
         */
        loadingColor: {
            type: String,
            default: 'accent',
        },

        /**
         *
         */
        loadingSize: {
            type: Number,
            default: 64,
        },

        /**
         *
         */
        loadingText: {
            type: String,
            default: 'Cargando datos...',
        },

        /**
         *
         */
        loadingWidth: {
            type: Number,
            default: 6,
        },

        /**
         *
         */
        noSubmit: Boolean,

        /**
         *
         */
        resetText: {
            type: String,
            default: 'limpiar',
        },

        /**
         *
         */
        switchEdit: Boolean,

        /**
         *
         */
        switchEditText: {
            type: String,
            default: 'Habilitar edición',
        },

        /**
         *
         */
        switchEditTooltip: {
            type: String,
            default: 'Haz clic aca para habilitar y deshabilitar la edición del formulario',
        },

        /**
         *
         */
        submitBlock: {
            type: Boolean,
            default: true,
        },

        /**
         *
         */
        submitColor: {
            type: String,
            default: 'primary',
        },

        /**
         *
         */
        submitDisabled: {
            type: Boolean,
            default: false,
        },

        /**
         *
         */
        submitDivider: {
            type: Boolean,
            default: true,
        },

        /**
         *
         */
        submitText: {
            type: String,
            default: 'enviar',
        },

        /**
         *
         */
        submitPrevent: Boolean,

        /**
         * Submit button type
         */
        submitType: {
            type: String,
            default: 'button',
        },

        /**
         * Form title
         */
        title: String,

        /**
         *
         */
        value: {
            type: Object,
            default: () => ({}),
        },

        /**
         *
         */
        variant: {
            type: String,
            default: 'plain',
        },
    },
    beforeMount() {
        this.reset()
    },
    watch: {
        /**
         *
         */
        edit() {
            this.$emit('editable', this.edit)
        },

        /**
         *
         */
        editable() {
            this.edit = this.editable
        },

        /**
         *
         */
        loading() {
            this.busy = this.loading
        },
    },
}
